var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1938 6.9668C12.1938 7.9786 11.8427 8.94897 11.2177 9.66442C10.5928 10.3799 9.74514 10.7818 8.86133 10.7818",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52761 27.8303H3.52923C2.82217 27.8303 2.14408 27.5087 1.64412 26.9363C1.14415 26.364 0.863281 25.5877 0.863281 24.7782V17.2689C0.863278 16.4858 1.07379 15.7217 1.46623 15.0802C1.85867 14.4388 2.41402 13.9512 3.05689 13.6836L6.86166 12.3771V10.0015C6.44889 9.64887 6.11352 9.19105 5.88215 8.66429C5.65078 8.13754 5.52976 7.55632 5.52869 6.96672V4.84197C5.51459 3.87362 5.81364 2.93349 6.36835 2.20227C6.92306 1.47106 7.69428 1.00037 8.53377 0.880687C8.99676 0.828471 9.46417 0.887797 9.90593 1.05485C10.3477 1.2219 10.754 1.49297 11.0987 1.85062C11.4435 2.20828 11.719 2.64459 11.9075 3.13149C12.0961 3.61838 12.1935 4.14509 12.1936 4.67769V6.9667C12.1925 7.5563 12.0715 8.1375 11.8401 8.66426C11.6087 9.19101 11.2734 9.64884 10.8606 10.0014V12.3771L14.68 13.7089C15.3193 13.9789 15.8709 14.4668 16.2605 15.1067C16.6501 15.7467 16.859 16.508 16.859 17.2881",
    stroke: "#EEEBE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19531 19.1748V24.0153H12.1932L9.52721 20.9633",
    stroke: "#EEEBE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5293 27.8302V30.8822",
    stroke: "#EEEBE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.587 28.0973L20.6171 20.423L20.5004 20.2223L13.1917 20.2002L10.4238 30.7617L10.5291 30.8822H16.3909",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1249 30.8822H16.459V28.6504L16.9922 27.8302H20.1913V29.051L19.1249 30.8822Z",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1934 6.9668C20.1934 7.9786 20.5445 8.94897 21.1694 9.66442C21.7944 10.3799 22.642 10.7818 23.5258 10.7818",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5227 30.8823V17.2689C31.5227 16.4858 31.3122 15.7217 30.9197 15.0802C30.5273 14.4388 29.9719 13.9512 29.3291 13.6836L25.5243 12.3771V10.0015C25.9371 9.64887 26.2725 9.19105 26.5038 8.66429C26.7352 8.13754 26.8562 7.55632 26.8573 6.96672V4.84197C26.8714 3.87362 26.5723 2.93349 26.0176 2.20227C25.4629 1.47106 24.6917 1.00037 23.8522 0.880687C23.3892 0.828471 22.9218 0.887797 22.48 1.05485C22.0383 1.2219 21.632 1.49297 21.2872 1.85062C20.9425 2.20828 20.667 2.64459 20.4784 3.13149C20.2899 3.61838 20.1925 4.14509 20.1924 4.67769V6.9667C20.1935 7.5563 20.3145 8.1375 20.5459 8.66426C20.7773 9.19101 21.1126 9.64884 21.5254 10.0014V12.3771L18.0137 13.6675",
    stroke: "#EEEBE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1895 19.1748V30.8823",
    stroke: "#EEEBE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon04);
export default __webpack_public_path__ + "static/media/icon04.45c48c99bf8a0bb3975df13e8f284392.svg";
export { ForwardRef as ReactComponent };